'use client'

// src/api/common/image.ts
var IMAGE_QUERY = `
title
sys{
  id
  publishedAt
}
url
width
height
contentType
`;

export {
  IMAGE_QUERY
};
//# sourceMappingURL=chunk-CWCKFIZP.mjs.map